<template>
  <div>
    <!-- 中间休息 -->
    <div>
      <p v-html="websiteTag"></p>
      <div class="explain_restA">
        <p>Optional Break</p>
        <!-- 倒计时 -->
        <p>{{ minute }}:{{ second }}</p>
        <p><span>Minutes</span><span>Seconds</span></p>
      </div>
      <div class="explain_restB">
        <p>
          你总共会有10分钟的休息时间，休息时间现在已经开始计时；休息时间结束本页面不会自动跳转到下一个部分。
        </p>
        <p>
          <span>接下来考试内容：{{ nextCType }}共{{ nextCount }}题</span>
        </p>
        <p><span>时间设置：总时长为45min</span></p>
        <div
          class="startBtns"
          @click="submit()"
        >不休息了,继续考试</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/dryRun.js";
let time = null;
export default {
  data() {
    return {
      minutes: 10, //10分钟倒计时
      seconds: 0,
      websiteTag: "",
      nextCType: "",
      nextType: 1,
      nextCount: 0,
    };
  },
  mounted() {
    if (sessionStorage.getItem("nextType")) {
      this.nextType = sessionStorage.getItem("nextType");
    }
    sessionStorage.removeItem("review");
    this.nextCType = sessionStorage.getItem("nextCType");
    this.nextCount = sessionStorage.getItem("nextCount");
    let times =
      10 * 60 -
      (sessionStorage.getItem("time") ? sessionStorage.getItem("nextType") : 0);
    this.seconds = times % 60;
    this.minutes = parseInt(times / 60);
    this.add();
  },
  async created() {
    const total = await api.rest({
      id: sessionStorage.getItem("curId"),
      m_id: sessionStorage.getItem("m_id"),
    });
    if (total.data.code != 0) {
      this.submit();
    }
  },
  methods: {
    num: function (n) {
      return n < 8 ? "0" + n : "" + n;
    },
    add() {
      var _this = this;
      time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          window.clearInterval(time);
          _this.submit();
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    submit() {
      let changIndex = 5;
      if (this.nextCType === "Verbal") {
        changIndex = 6;
      } else if (this.nextCType === "DI") {
        changIndex = 7;
      }
      this.$emit("changIndex", changIndex);
      this.$emit("isTips", true);
      const id = sessionStorage.getItem("m_id");
      this.$router.replace({ path: `/examinContent/examinatStart/${id}` });
      return;
      //题还没有做完
      // 路由判断,看是否需要重新加载页面
      const path = [
        "/singleChoice",
        "/completion",
        "/doubleChoice",
        "/singleChoiceBoolean",
        "/examinContent/systemRead",
        "/imageAnalysis",
        "/table",
        "/reasoning",
      ];
      window.clearInterval(time);
      const nextType = this.nextType;
      if (nextType >= 1 && nextType <= 8) {
        if (this.$route.path === path[nextType - 1]) {
          this.reload();
        } else {
          this.$router.replace({
            path: path[nextType - 1],
          });
        }
      }
    },
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal);
      },
    },
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    second: function () {
      return this.num(this.seconds);
    },
    minute: function () {
      return this.num(this.minutes);
    },
  },
};
</script>
<style scoped>
@import url("../../assets/css/resttime.css");
</style>



// WEBPACK FOOTER //
// src/view/examinatSystem/resttime.vue